module.exports = __webpack_public_path__ + "wp_numbers3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wp_numbers3.jpg
// module id = 422
// module chunks = 0